import { RadioGroup, RadioGroupChangeEvent } from '@progress/kendo-react-inputs';
import { useCallback } from 'react';
import TransferList, {
  DefaultTransferListDataType,
  resetTransferList,
} from 'src/components/TransferList';
import usePeriodView from 'src/hooks/usePeriodView';
import { SetState } from 'src/types/generic';
import { AttributesOption } from '../../PeriodViewContext';
import { approvalWorkflowOptions } from './ApprovalWorkflow';

interface Option {
  value: AttributesOption;
  label: string;
}

const options: Option[] = [
  { value: 'OFF', label: 'OFF' },
  { value: 'Required', label: 'Always Require Approval' },
  { value: 'Exempt', label: 'Always Exempt from Approval' },
];

interface Props<D extends DefaultTransferListDataType> {
  title: string;
  leftList: D[];
  rightList: D[];
  setLeftList: SetState<D[]>;
  setRightList: SetState<D[]>;
  option: AttributesOption;
  setOption: SetState<AttributesOption>;
  isPoWorkFlow: boolean;
}

function Workflow<D extends DefaultTransferListDataType>({
  title,
  leftList,
  rightList,
  setLeftList,
  setRightList,
  option,
  setOption,
  isPoWorkFlow,
}: Props<D>) {
  const {
    bulkAssignRefresher,
    confirmBeforeProceedingToMainScreen,
    isPoWorkFlowDirty,
    isInvoiceWorkFlowDirty,
  } = usePeriodView();

  const handleChange = useCallback(
    (event: RadioGroupChangeEvent) => {
      const proceedWithChange = () => {
        setOption(event.value as AttributesOption);
        resetTransferList(setLeftList, setRightList, leftList, rightList);
      };

      if ((isPoWorkFlow && isPoWorkFlowDirty) || (!isPoWorkFlow && isInvoiceWorkFlowDirty)) {
        confirmBeforeProceedingToMainScreen(proceedWithChange);
      } else {
        setOption(event.value as AttributesOption);
        const touchedItems = rightList.map((item) => ({ ...item, isDirty: true }));
        setLeftList([...leftList, ...touchedItems]);
        setRightList([]);
      }
    },
    [
      confirmBeforeProceedingToMainScreen,
      isInvoiceWorkFlowDirty,
      isPoWorkFlow,
      isPoWorkFlowDirty,
      leftList,
      rightList,
      setLeftList,
      setOption,
      setRightList,
    ]
  );
  return (
    <div className={` px-2 pt-1 w-1/2 min-h-[calc(100vh-250px)]  `}>
      <p className="font-bold text-md"> {title} </p>
      <div className="mt-1">
        <span className="mr-2">
          <RadioGroup data={options} value={option} onChange={handleChange} layout="horizontal" />
        </span>
      </div>

      {option === 'OFF' ? (
        <p className="text-error">
          Contact assignment not required when approval attribute set to 'OFF'
        </p>
      ) : (
        <TransferList
          leftList={leftList}
          rightList={rightList}
          title="Contacts"
          leftListTitle="Unassigned Contacts"
          rightListTitle="Assigned Contacts"
          searchPlaceholder="Filter by contact..."
          setLeftList={setLeftList}
          setRightList={setRightList}
          height="calc(100vh - 280px)"
          categories={approvalWorkflowOptions}
          bulkAssignRefresher={bulkAssignRefresher}
          label="contact(s)"
          deletedItemLabel="(disabled)"
          isSidePanel={true}
        />
      )}
    </div>
  );
}

export default Workflow;
